import { useState } from "react";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    IconButton,
    Stack,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";


const CrearBanner = ({
    open,
    onClose,
    onSubmit,
    loading,
}) => {

    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [link, setLink] = useState("");
    const [nameButton, setNameButton] = useState("");
    const [posicion, setPosicion] = useState("");
    const [imagen, setImagen] = useState(null);

    const [preview, setPreview] = useState(null);


    /*
    |--------------------------------------------------------------------------
    | IMAGEN
    |--------------------------------------------------------------------------
    */

    const handleImagen = (event) => {

        const file = event.target.files[0];

        if (!file) return;

        setImagen(file);

        setPreview(
            URL.createObjectURL(file)
        );
    };


    /*
    |--------------------------------------------------------------------------
    | CREAR
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async () => {

        const formData = new FormData();

        formData.append(
            "titulo",
            titulo
        );

        formData.append(
            "descripcion",
            descripcion
        );

        formData.append(
            "link",
            link
        );

        formData.append(
            "name_button",
            nameButton
        );

        formData.append(
            "posicion",
            posicion
        );

        if (imagen) {

            formData.append(
                "imagen",
                imagen
            );

        }

        await onSubmit(formData);

    };


    /*
    |--------------------------------------------------------------------------
    | CERRAR
    |--------------------------------------------------------------------------
    */

    const handleClose = () => {

        setTitulo("");
        setDescripcion("");
        setLink("");
        setNameButton("");
        setPosicion("");
        setImagen(null);
        setPreview(null);

        onClose();

    };


    return (

        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
        >

            {/* HEADER */}

            <DialogTitle
                sx={{
                    px: 4,
                    pt: 3,

                    fontWeight: 800,

                    color: "#12213F",

                    fontFamily: "Archivo",
                }}
            >

                Crear nuevo banner

                <IconButton
                    onClick={handleClose}

                    sx={{
                        position: "absolute",
                        right: 18,
                        top: 18,

                        color: "#687083",
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>

            </DialogTitle>


            <DialogContent
                sx={{
                    px: {
                        xs: 3,
                        md: 4,
                    },

                    pb: 2,
                }}
            >

                <Stack spacing={2.5}>

                    {/* ================================================= */}
                    {/* IMAGEN */}
                    {/* ================================================= */}

                    <Box>

                        <Typography
                            sx={{
                                mb: 1,

                                fontWeight: 700,

                                color: "#12213F",
                            }}
                        >
                            Imagen del banner
                        </Typography>


                        <Button
                            component="label"

                            variant="outlined"

                            startIcon={
                                <CloudUploadRoundedIcon />
                            }

                            sx={{
                                borderRadius: "12px",

                                textTransform:
                                    "none",

                                fontWeight: 700,

                                borderColor:
                                    "#d8dce5",

                                color: "#484a75",

                                py: 1.2,
                            }}
                        >

                            Seleccionar imagen

                            <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={
                                    handleImagen
                                }
                            />

                        </Button>


                        {preview && (

                            <Box
                                component="img"
                                src={preview}

                                sx={{
                                    mt: 2,

                                    width: "100%",

                                    height: 220,

                                    objectFit:
                                        "cover",

                                    borderRadius:
                                        "16px",
                                }}
                            />

                        )}

                    </Box>


                    {/* ================================================= */}
                    {/* TITULO */}
                    {/* ================================================= */}

                    <TextField
                        label="Título"
                        value={titulo}
                        onChange={(e) =>
                            setTitulo(
                                e.target.value
                            )
                        }

                        fullWidth

                        placeholder="Ej: Admisión 2027"

                    />


                    {/* ================================================= */}
                    {/* DESCRIPCIÓN */}
                    {/* ================================================= */}

                    <TextField
                        label="Descripción"
                        value={descripcion}
                        onChange={(e) =>
                            setDescripcion(
                                e.target.value
                            )
                        }

                        fullWidth

                        multiline
                        rows={4}

                        placeholder="Descripción del banner..."
                    />


                    {/* ================================================= */}
                    {/* LINK */}
                    {/* ================================================= */}

                    <TextField
                        label="Link"
                        value={link}
                        onChange={(e) =>
                            setLink(
                                e.target.value
                            )
                        }

                        fullWidth

                        placeholder="/admision"
                    />


                    {/* ================================================= */}
                    {/* NOMBRE BOTÓN */}
                    {/* ================================================= */}

                    <TextField
                        label="Nombre del botón"
                        value={nameButton}
                        onChange={(e) =>
                            setNameButton(
                                e.target.value
                            )
                        }

                        fullWidth

                        placeholder="Ver más"
                    />


                    {/* ================================================= */}
                    {/* POSICIÓN */}
                    {/* ================================================= */}

                    <TextField
                        label="Posición"
                        type="number"

                        value={posicion}
                        onChange={(e) =>
                            setPosicion(
                                e.target.value
                            )
                        }

                        fullWidth

                        placeholder="1"
                    />

                </Stack>

            </DialogContent>


            {/* ACTIONS */}

            <DialogActions
                sx={{
                    px: 4,
                    pb: 3,
                    gap: 1,
                }}
            >

                <Button
                    onClick={handleClose}

                    sx={{
                        textTransform: "none",

                        fontWeight: 700,

                        color: "#687083",

                        borderRadius: "12px",
                    }}
                >
                    Cancelar
                </Button>


                <Button
                    variant="contained"

                    disabled={loading}

                    onClick={handleSubmit}

                    sx={{
                        borderRadius: "12px",

                        px: 3,

                        py: 1.2,

                        textTransform: "none",

                        fontWeight: 700,

                        background:
                            "linear-gradient(135deg,#C62828,#8f1515)",

                        boxShadow: "none",
                    }}
                >

                    {loading
                        ? "Guardando..."
                        : "Crear banner"}

                </Button>

            </DialogActions>

        </Dialog>

    );
};


export default CrearBanner;